import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {StoreModule} from '@ngrx/store';
import {metaReducers, reducers} from './reducers';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {environment} from '../environments/environment';
import {EffectsModule} from '@ngrx/effects';
import {AppEffects} from './app.effects';
import {AuthModule} from './modules/core/auth/auth.module';
import {AuthGuard} from './modules/core/auth/auth.guard';
import {AuthState} from './modules/core/auth/store/auth.state';
import {HttpClientModule} from '@angular/common/http';
import {BackendService} from './modules/core/services/backend.service';
import {ManagerState} from './modules/file-manager/manager.state';

import {RouterStateSerializer, StoreRouterConnectingModule} from "@ngrx/router-store";
import {CustomRouterStateSerializer} from './reducers/utils';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        AuthModule,
        HttpClientModule,
        StoreRouterConnectingModule.forRoot({
            /*
              They stateKey defines the name of the state used by the router-store reducer.
              This matches the key defined in the map of reducers
            */
            stateKey: 'router',
        }),
        StoreModule.forRoot(reducers, {metaReducers}),
        !environment.production ? StoreDevtoolsModule.instrument() : [],
        EffectsModule.forRoot([AppEffects]),
        ToastrModule.forRoot()
    ],
    providers: [
        {provide: RouterStateSerializer, useClass: CustomRouterStateSerializer},
        AuthGuard,
        AuthState,
        BackendService,
        ManagerState
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
